/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Select_NoneInputs */

const en_forms_select_none = /** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear All`)
};

const de_forms_select_none = /** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle löschen`)
};

const es_forms_select_none = /** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deseleccionar todo`)
};

const fr_forms_select_none = /** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout effacer`)
};

/** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */
const it_forms_select_none = en_forms_select_none;

/** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */
const pt_br2_forms_select_none = en_forms_select_none;

/** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */
const pl_forms_select_none = en_forms_select_none;

/** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */
const hu_forms_select_none = en_forms_select_none;

/** @type {(inputs: Forms_Select_NoneInputs) => LocalizedString} */
const ro_forms_select_none = en_forms_select_none;

/**
* | output |
* | --- |
* | "Clear All" |
*
* @param {Forms_Select_NoneInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const forms_select_none = /** @type {((inputs?: Forms_Select_NoneInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Select_NoneInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_select_none(inputs)
	if (locale === "de") return de_forms_select_none(inputs)
	if (locale === "es") return es_forms_select_none(inputs)
	if (locale === "fr") return fr_forms_select_none(inputs)
	if (locale === "it") return it_forms_select_none(inputs)
	if (locale === "pt-BR") return pt_br2_forms_select_none(inputs)
	if (locale === "pl") return pl_forms_select_none(inputs)
	if (locale === "hu") return hu_forms_select_none(inputs)
	return ro_forms_select_none(inputs)
});
export { forms_select_none as "forms.select_none" }